import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import _ from 'lodash';
import styled from 'styled-components';
import {setFormV2ToasterVisibility} from '../../../actions/toastactions';
import Utility from '../../../util/utilityfunctions';
import {modalLevelToast} from '../../../util/uiconstants';
import ErrorsUtility from './index';
import ToastMessageContainer from '../ToastMessage/ToastMessageContainer';

export default function ModalError({modalLevel}) {
	const errors = useSelector((store) => store.errors),
		isModalOpen = useSelector((store) => store.isModalOpen),
		isADCModalOpen = useSelector((store) => store.isADCModalOpen),
		currentModalLevel = useSelector((store) => store.modalLevel);

	const dispatch = useDispatch();
	const showErrors = isModalOpen && !isADCModalOpen && currentModalLevel === modalLevel;
	const toastMessageFeatureName = 'Modal';

	const addNotification = (level, message, autoDismissInSeconds) => {
		isModalOpen &&
			dispatch(
				setFormV2ToasterVisibility(true, level, Utility.createRichTextElement(message), '', autoDismissInSeconds)
			);
	};

	useEffect(() => {
		ErrorsUtility.addNotification(errors, addNotification);
	}, [errors]);

	return (
		<StyledModalBanners className="StyledModalBanners StyledModalBannersErrors">
			{showErrors && (
				<ToastMessageContainer toastFeature={toastMessageFeatureName} className="modal-messages-container" />
			)}
		</StyledModalBanners>
	);
}

const StyledModalBanners = styled.section`
	position: absolute;
	width: calc(100% - 2 * calc(var(--spacing-x-large)));
	display: flex;
	flex-direction: column;
	z-index: 9;
	.bannerLabel.InsufficientRightsBannerLabel {
		width: calc(100vw - var(--px-160)) !important;
	}
`;

ModalError.defaultProps = {
	modalLevel: modalLevelToast.level1
};
